module.exports = __webpack_public_path__ + "img/vk-c.269a301.png";